import {
  SET_ATTRIBUTE_AS_CHANGING,
  UPDATE_CHANGING_ATTRIBUTES,
  MARK_ATTRIBUTES_SET_AS_CHANGING,
  UNMARK_ATTRIBUTES_SET_AS_CHANGING,
  SET_ATTRIBUTES_SET_CHANGING_STATUS,
  SET_PRODUCTS_INDEX_STATUS,
  SET_PRODUCTS_DELETE_STATUS,
  SET_IMPORT_CATALOG_STATUS,
  SET_DATA_INDEX_STATUS,
  SET_ADDING_NEW_DATA_STATUS,
  SET_UPLOADING_FILES_STATUS,
  SET_ADDING_NEW_ADMIN_STATUS,
  SET_IMPORT_SOMEONE_CATALOG_STATUS,
  SET_IMPORT_UPLOADING_FILES_STATUS,
  SET_IMPORT_DATA_STATUS,
  SET_INDEX_PROGRESS,
  CLEAR_INDEX_PROGRESS,
  SET_INDEX_LAST_ERROR,
  CLEAR_INDEX_LAST_ERROR,
  SET_INDEX_HEALTH,
  SET_PREVIEW_REGEN_STATUS,
  SET_PREVIEW_REGEN_PROGRESS,
  CLEAR_PREVIEW_REGEN_PROGRESS
} from './action';

const initialState = {
  attributesInSets: [],
  attributeSets: [],
  // индексация товаров
  isRunningIndex: false,
  // индексация данных
  isRunningDataIndex: false,
  isChangingAttributes: false,
  // я запустил импорт каталога
  isRunningImportCatalog: false,
  // я запустил импорт данных
  isRunningImportData: false,
  // кто то запустил импорт каталога
  isSomeoneRunningImportCatalog: false,
  // блокировки по операциям
  addingNewDataIsBlocked: false,
  uploadingFilesIsBlocked: false,
  addingNewAdminBlocked: false,
  // импорт 2 загрузка файлов
  isRunningUploadFiles: false,
  // расширенные данные пайплайна индексации
  indexProgress: null,
  indexLastError: null,
  indexHealth: null,
  // перегенерация превью по шаблону
  isRunningPreviewRegen: false,
  previewRegenProgress: null,
};

export default (state = initialState, { type, payload }) => {
  // console.log(`type: ${type}, payload: ${payload}`);
  switch (type) {
  case SET_ATTRIBUTE_AS_CHANGING:

    const c = state.attributesInSets.filter((c) => c.id !== payload?.id);
    return {
      ...state,
      attributesInSets: c.concat([payload])
    };
  case UPDATE_CHANGING_ATTRIBUTES:
    return {
      ...state,
      attributesInSets: payload
    };
  case MARK_ATTRIBUTES_SET_AS_CHANGING:
    return {
      ...state,
      attributeSets: payload && !state.attributeSets.includes(payload)
        ? state.attributeSets.concat([payload])
        : state.attributeSets
    };
  case UNMARK_ATTRIBUTES_SET_AS_CHANGING:
    return {
      ...state,
      attributeSets: payload && state.attributeSets.includes(payload)
        ? state.attributeSets.filter((c) => c !== payload)
        : state.attributeSets
    };
  case SET_ATTRIBUTES_SET_CHANGING_STATUS:
    return {
      ...state,
      isChangingAttributes: payload
    };
  case SET_PRODUCTS_INDEX_STATUS:
    return {
      ...state,
      isRunningIndex: payload
    };
  case SET_PRODUCTS_DELETE_STATUS:
    return {
      ...state,
      isRunningIndex: payload
    };
  case SET_DATA_INDEX_STATUS:
    return {
      ...state,
      isRunningDataIndex: payload
    };
  case SET_ADDING_NEW_DATA_STATUS:
    return {
      ...state,
      addingNewDataIsBlocked: payload
    };
  case SET_ADDING_NEW_ADMIN_STATUS:
    return {
      ...state,
      addingNewAdminBlocked: payload
    };
  case SET_UPLOADING_FILES_STATUS:
    return {
      ...state,
      uploadingFilesIsBlocked: payload
    };
  case SET_IMPORT_CATALOG_STATUS:
    return {
      ...state,
      isRunningImportCatalog: payload
    };
    case SET_IMPORT_DATA_STATUS:
      return {
        ...state,
        isRunningImportData: payload
      };
  case SET_IMPORT_UPLOADING_FILES_STATUS:
    return {
      ...state,
      isRunningUploadFiles: payload
    };
  case SET_IMPORT_SOMEONE_CATALOG_STATUS:
    return {
      ...state,
      isSomeoneRunningImportCatalog: payload
    };
  case SET_INDEX_PROGRESS:
    return {
      ...state,
      indexProgress: {
        ...(state.indexProgress || {}),
        ...(payload || {}),
      }
    };
  case CLEAR_INDEX_PROGRESS:
    return {
      ...state,
      indexProgress: null
    };
  case SET_INDEX_LAST_ERROR:
    return {
      ...state,
      indexLastError: payload
    };
  case CLEAR_INDEX_LAST_ERROR:
    return {
      ...state,
      indexLastError: null
    };
  case SET_INDEX_HEALTH:
    return {
      ...state,
      indexHealth: payload
    };
  case SET_PREVIEW_REGEN_STATUS:
    return {
      ...state,
      isRunningPreviewRegen: payload
    };
  case SET_PREVIEW_REGEN_PROGRESS:
    return {
      ...state,
      previewRegenProgress: {
        ...(state.previewRegenProgress || {}),
        ...(payload || {}),
      }
    };
  case CLEAR_PREVIEW_REGEN_PROGRESS:
    return {
      ...state,
      previewRegenProgress: null
    };
    default:
    return { ...state };
  }
};
